import script from "./CourseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseEdit.vue?vue&type=script&setup=true&lang=js"

import "./CourseEdit.vue?vue&type=style&index=0&id=f7749bdc&lang=css"

const __exports__ = script;

export default __exports__